import React, {useState} from 'react';
import styles from './ItemCard.module.css';
import folderIcon from '../../../assets/img/folderIcon.svg'
import fileIcon from '../../../assets/img/fileIcon.svg'
import Modal from "react-bootstrap/Modal";
import sButtons from "../../../assets/styles/buttons.module.css";
import stylesModal from "../KBModal/KBModal.module.css";
import {useDeleteKBFile} from "../../../hooks/useQuery/useDeleteKBFile";
import {IFile} from "../../../types/knowledgeBase.types";
import {VideoPlayer} from "../../shared/VideoPlayer/VideoPlayer";
import {API_URL_V2} from "../../../config";
import {KNOWLEDGE_BASE_ENDPOINTS} from "../../../services/network/endpoints";
// Функция для получения расширения файла
const getFileExtension = (filename: string): string => {
    const lastDotIndex = filename.lastIndexOf('.');
    return lastDotIndex === -1 ? '' : filename.substring(lastDotIndex);
};

interface ItemCardProps {
    type: 'folder' | 'file' | 'video';
    name: string;
    id: string;
    originalName?: string;
    isAdmin: boolean;
    onClick: () => void;
    file?: IFile;
    pathCover?: string | null;
}

export const ItemCard: React.FC<ItemCardProps> = ({
                                                      type,
                                                      name,
                                                      id,
                                                      originalName,
                                                      isAdmin,
                                                      onClick,
                                                      pathCover,
    file,
                                                  }) => {
    const [showDeleteModal, setShowDeleteModal] = useState(false);


    const handleDelete = (e: React.MouseEvent) => {
        e.stopPropagation();
        setShowDeleteModal(true);
    };
    const deleteFile = useDeleteKBFile(file?.folderId)

    const confirmDelete = async () => {
        await deleteFile.mutateAsync(id)
        setShowDeleteModal(false);
    };
    const [showVideoModal, setShowVideoModal] = useState(false);
    const displayName = type === 'file' && originalName
        ? `${name}${getFileExtension(originalName)}`
        : name;
    return (
        <>
            <div title={displayName} className={`${styles.itemCard} ${type === 'file' ? styles.itemFile : ""}`} onClick={file?.type !== 'video' ? onClick : ()=>setShowVideoModal(true)}>
                <span className={styles.icon}>
                    {(type === 'folder' || file?.type === 'video') ? (
                        <img
                            src={pathCover ? pathCover : folderIcon}
                            className={pathCover ? styles.notDefaultImg : ""}
                            alt="folderIcon"
                        />
                    ) : (
                        <img src={fileIcon} alt="fileIcon" />
                    )}
                </span>
                <span className={styles.name}>{displayName}</span>
                {isAdmin && type === 'file' && (
                    <button className={styles.deleteButton} onClick={handleDelete}>
                        ×
                    </button>
                )}
            </div>

            {showDeleteModal && (
                <Modal
                    show={showDeleteModal}
                    onHide={() => setShowDeleteModal(false)}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    dialogClassName={stylesModal.eventModalDialog}
                    contentClassName={stylesModal.modalContent}
                >
                    <Modal.Header closeButton className={stylesModal.modalHeader}>
                        <Modal.Title id="contained-modal-title-vcenter">Удаление файла</Modal.Title>
                    </Modal.Header>

                    <Modal.Body className={stylesModal.modalBody}>
                        <p>Вы действительно хотите удалить файл <strong>{displayName}</strong>? После удаления
                            восстановление файла невозможно</p>
                    </Modal.Body>

                    <div className={`d-flex gap-3 ${stylesModal.buttonsWrapper}`}>

                        <button
                            type="button"
                            className={sButtons.dangerButton}
                            onClick={confirmDelete}
                        >
                            Удалить файл
                        </button>

                    </div>
                </Modal>
            )}
            {(showVideoModal && file) && (
                <Modal
                    show={showVideoModal}
                    onHide={() => setShowVideoModal(false)}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    dialogClassName={styles.videoModalDialog}
                    contentClassName={styles.modalContent}
                >
                    <Modal.Header closeButton className={stylesModal.modalHeader}>
                        <Modal.Title id="contained-modal-title-vcenter">{file.name}</Modal.Title>
                    </Modal.Header>
                    <VideoPlayer
                        options={{
                            sources: [
                                {
                                    src: `${API_URL_V2}${KNOWLEDGE_BASE_ENDPOINTS.GET_FILE}/${file._id}`,
                                    type: file.mimeType
                                }
                            ]
                        }}
                    />
                </Modal>
            )}
        </>
    );
};
